let marginMap: Record<string, string> = {
  none: '0',
  small: '4',
  medium: '8',
  large: '16',
  xl: '32',
};

export function setMargins(margins: Record<string, string>) {
  marginMap = margins;
}

export function getMarginClassName(margin?: string | null): string {
  if (!margin) return '0';
  return marginMap[margin];
}
